/* eslint-disable */

import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import { GET_BOOKMARKS, GET_BOOKMARKS_SUCCESS, GET_BOOKMARKS_FAIL } from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getBookmarks() {
  yield takeEvery(GET_BOOKMARKS, function* () : any {
    try {
      const response = yield Request.get('movie/movie/list/tagid/2001484');
      if (_.get(response, ['data'])) {
        yield put({
          type: GET_BOOKMARKS_SUCCESS,
          data: _.get(response, ['data']),
        });
      } else {
        yield put({ type: GET_BOOKMARKS_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_BOOKMARKS_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getBookmarks),
  ]);
}
